import * as yup from "yup";

declare module "yup" {
   export interface StringSchema {
      /**
       * Check for phone number validity.
       *       
       * @param {String} [errorMessage=DEFAULT_MESSAGE] The error message to return if the validation fails.
       */
      phone(         
         errorMessage?: string
      ): StringSchema;
   }
}

const YUP_PHONE_METHOD = "phone";

yup.addMethod(yup.string, YUP_PHONE_METHOD, function yupPhone(
   errorMessage: string = ""
) {
   const errMsg =
      typeof errorMessage === "string" && errorMessage
         ? errorMessage
         : "${path} must be a valid phone number.";
   // @ts-ignore
   return this.test(YUP_PHONE_METHOD, errMsg, async (value: string) => {
      if (!value) {
         return true;
      }
      var result = value && value.length > 2;
      try {
         const gPhoneNumber = await import("google-libphonenumber");
         const phoneUtil = gPhoneNumber.PhoneNumberUtil.getInstance();
         var phoneNumber: libphonenumber.PhoneNumber | null = null;
         //allow any supported country
         for (var i = 0; i < LiquidSpaceConfig.SupportedCountries.length; i++) {
            phoneNumber = phoneUtil.parse(value, LiquidSpaceConfig.SupportedCountries[i] ?? undefined);
            result = phoneUtil.isValidNumberForRegion(phoneNumber, LiquidSpaceConfig.SupportedCountries[i] ?? undefined);

            if (result)
               break;
         }
         //if not found in supported - try parse as international
         if (!result /*&& (params.allowInternational || true)*/) {
            var internationalNumberPrefix = "+";
            if (value.indexOf(internationalNumberPrefix, 0) == -1) {
               phoneNumber = phoneUtil.parse(internationalNumberPrefix + value);
            } else {
               phoneNumber = phoneUtil.parse(value);
            }
            result = phoneUtil.isValidNumber(phoneNumber);
         }         
         // DEVONLY
         if (!result && (LiquidSpaceConfig.Environment == Enum.EnvironmentType.Development || LiquidSpaceConfig.Environment == Enum.EnvironmentType.Staging)) {
            phoneNumber = phoneUtil.parse(value, "BY");
            result = phoneUtil.isValidNumberForRegion(phoneNumber, "BY");
         }
         // DEVONLY
      } catch (e) {
         result = false;
      }

      return result;
   });
});
